import React from 'react';
import { Form } from 'antd';
import styles from './index.module.scss';

// `hint` là dòng gợi ý dưới ô nhập (vd "(Ví dụ: SN2024HA8899...)"). Để trong FormField chứ không
// đặt thành thẻ anh em bên ngoài, nếu không nó bị đẩy xuống bởi margin-bottom của Form.Item.
const FormField = ({ label, required, name, rules, placeholder, value, onChange, hint }) => (
  <div className={styles['input-field']}>
    <div className={styles['label']}>
      {label} {required && <span className={styles['required']}>(*)</span>}
    </div>
    <Form.Item name={name} rules={rules}>
      <input name={name} className={styles['input']} placeholder={placeholder} value={value} onChange={onChange} />
    </Form.Item>
    {hint && <div className={styles['hint']}>{hint}</div>}
  </div>
);

export default FormField;
